import { useState } from 'react';
import * as React from 'react'
import { AreaChart, Area, XAxis, YAxis } from 'recharts';
import { Fieldset } from 'primereact/fieldset';
import { formatMoney } from '../Utilities/FormatMoney';
import { IGraficoKPI } from '../../../interfaces/IGraficoKPI';

interface IProps {
    VolumenConsumido: number,
    CantidadTRX: number,
    VolumenConsumidoPromedioTRX: number,
    titulo: string,
    Data: IGraficoKPI | any,
    tipo: string
}

export const Ultimos = (props:IProps) => {

    const volumenConsumido = formatMoney(props.VolumenConsumido, 0);
    const volumenConsumidoPromedioTRX = formatMoney(props.VolumenConsumidoPromedioTRX, 0);
    const cantidadTRX = formatMoney(props.CantidadTRX, 0);
    const [dimensions, setDimensions] = useState<any>({})

    React.useEffect(() => {
        updateWindowDimensions();
    }, []);  

    async function  updateWindowDimensions() {
        var factor = 0.361;
        if (window.innerWidth <= 1800)
        var factor = 0.358;
        if (window.innerWidth <= 1700)
        var factor = 0.354;
        if (window.innerWidth <= 1600)
            factor = 0.348;
        if (window.innerWidth <= 1400)
            factor = 0.342;
        if (window.innerWidth <= 1280)
            factor = 0.436;
        if (window.innerWidth <= 1250)
            factor = 0.433;
        if (window.innerWidth <= 1220)
            factor = 0.429;
        if (window.innerWidth <= 1070)
            factor = 0.426;
        if (window.innerWidth <= 1024)
            factor = 0.412;
        if (window.innerWidth <= 900)
            factor = 0.40;
        if (window.innerWidth <= 800)
            factor = 0.39;
        if (window.innerWidth <= 700)
            factor = 0.38;
        if (window.innerWidth <= 600)
            factor = 0.36;
        if (window.innerWidth <= 500)
            factor = 0.34;
        setDimensions({width: window.innerWidth, height: window.innerHeight, factor: factor})
    };


return (
            <Fieldset key={props.tipo} legend={props.titulo}>
                <div className="row">
                    <div className="col-8 d-flex align-items-center">
                        <div className="row ml-4">
                            <div className="d-flex flex-column">
                                <span className="h5 mb-0">
                                    <span className="t3">$ </span>
                                    <span>{volumenConsumido}</span>
                                </span>
                                <span className="font-weight-bold t8 c1 text-center">Volumen Consumido</span>
                            </div>
                        </div>
                    </div>
                    <div className="col-4">
                        <div className="row d-flex justify-content-center mb-2">
                            <div className="d-flex flex-column text-center">
                                <span className="t3">{cantidadTRX}</span>
                                <span className="font-weight-bold n4 c1">Cantidad de Transacciones</span>
                            </div>
                        </div>
                        <div className="row d-flex justify-content-center">
                            <div className="d-flex flex-column text-center">
                                <span className="t3">
                                    <span className="t5">$ </span>
                                    <span>{volumenConsumidoPromedioTRX}</span>
                                </span>
                                <span className="font-weight-bold n4 c1">Consumo promedio por Transacción</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ width: "100%", height: "100px", border: "0px", paddingTop: "0px", paddingLeft: "4px" }}>
                    {props.Data != undefined ?
                        <AreaChart width={dimensions.width * dimensions.factor}
                            margin={{ top: 0, right: 0, left: -60, bottom: 0 }}
                            height={100}
                            data={props.Data}
                            className="text-center kpi-chart">
                            <YAxis tick={false} axisLine={false} />
                            <XAxis
                                dataKey={props.tipo == "Dia" ? "fechaPresentacionDia" : "fechaPresentacionMes"}
                                tick={{ stroke: '#162056', strokeWidth: 0, fontSize: '0.6rem' }}
                                tickCount={12} />
                            <Area type="monotone" dataKey="monto" stroke="#7FC2E4" fill="#7FC2E4" dot={<div></div>} />
                        </AreaChart>
                        :
                        <div>
                        </div>
                    }
                </div>
            </Fieldset >
    );
}
export default Ultimos